import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  searchQuery: '',
  searchDropValue: undefined,
  selectedTabValue: '2',
};

const usersSearchSlice = createSlice({
  name: 'usersSearch',
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.searchQuery = action.payload;
    },
    setSearchDropValue: (state, action) => {
      state.searchDropValue = action.payload;
    },
    setSelectedTabValue: (state, action) => {
      state.selectedTabValue = action.payload;
    },
    clearSearch: (state) => {
      state.searchQuery = '';
      state.searchDropValue = undefined;
    },
    resetUsersSearch: (state) => {
      return initialState;
    },
  },
});

export const {
  setSearchQuery,
  setSearchDropValue,
  setSelectedTabValue,
  clearSearch,
  resetUsersSearch,
} = usersSearchSlice.actions;

export default usersSearchSlice.reducer;
